module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACYSURBVHgB7ZPBDYAgDEW/OojoJk7uJMY6iCKN8dK0hYQYL7yTsfV9LAA0GrV0VmEew87Fs8NCCa0nJPqIlfu2gyatp4dPGJKARY48eAIz4EorjwBpIUJO/JeWxxyRJ5LvrBFmA7SQ+HxUJC8KUEJQKmdym1xNNkAZEcE5XZL/NlmTvyKvJjFH5An4Wd4T0wMfc3UipNH4kBtpbHeUZDjIAwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close-outline.png
// module id = 352
// module chunks = 0